<div class="organizer-top">
  <div class="organizer-corner"></div>
  <div
    class="organizer-column-head"
    *ngFor="let column of columns; trackBy: trackByColumn"
  >
    <span class="organizer-column-label">{{ column.labelKey | baseBusinessKey | translate }}</span>
    <i
      *ngIf="column.icon"
      class="fa-regular fa-fw {{ column.icon }}"
    ></i>
  </div>
</div>

<div class="organizer-content">
  <div
    class="organizer-month"
    *ngFor="let group of monthGroups; trackBy: trackByGroup"
    [style.grid-row]="group.gridRow"
  >
    <span>{{ group.label }}</span>
  </div>

  <div
    class="organizer-week"
    *ngFor="let group of weekGroups; trackBy: trackByGroup"
    [style.grid-row]="group.gridRow"
  >
    <span>{{ group.label }}</span>
  </div>

  <ng-container *ngFor="let day of days; let rowIndex = index; trackBy: trackByDay">
    <div
      class="organizer-day"
      [class.organizer-weekend]="day.dateItem.isWeekend"
      [class.organizer-first-row]="rowIndex === 0"
      [class.today]="day.dateItem.isToday"
      [style.grid-row]="rowIndex + 1"
    >
      <span class="organizer-day-number">{{ day.dateItem.day }}</span>
      <span class="organizer-day-weekday">{{ day.dateItem.weekdayShort }}</span>
    </div>

    <div
      class="organizer-cell"
      *ngFor="let bubble of day.bubbles; let columnIndex = index; trackBy: trackByBubble"
      [class.organizer-weekend]="day.dateItem.isWeekend"
      [class.organizer-first-row]="rowIndex === 0"
      [style.grid-row]="rowIndex + 1"
      [style.grid-column]="columnIndex + 4"
    >
      <base-customer-shift-plan-bubble
        [isCalendar]="true"
        [bubble]="bubble"
        [isVisible]="day.currentPosition?.isVisible ?? true"
        (bubbleClick)="bubbleClick.emit({ shift: $event, day: day })"
      ></base-customer-shift-plan-bubble>
    </div>
  </ng-container>
</div>

<div class="organizer-bottom d-flex align-items-center">
  <base-button
    color="transparent"
    icon="fa-solid fa-pen"
    [label]="'action.editShiftTimes' | baseBusinessKey"
    (btnClick)="editShiftTimes.emit()"
  ></base-button>
  <base-button
    color="transparent"
    label="inquiry.showInquiryInfo"
    (btnClick)="showInquiryInfo.emit()"
  ></base-button>
</div>
